import { defineComponent as _defineComponent } from 'vue'
import VsText from '@/components/vision/VsText.vue'
import { PickerItemType } from './models'
import { computed } from 'vue'

interface Props {
  item: PickerItemType
  isSelected?: boolean | null
  checkbox?: boolean | null
  checkboxColor?: string | null
  prependIcon?: boolean | null
  dense?: boolean | null
  truncate?: boolean | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PickerListItem',
  props: {
    item: { default: () => ({
    id: null,
    title: '',
    subTitle: null,
    childCount: 0,
    expandable: false,
    selectable: true,
  }) },
    isSelected: { type: [Boolean, null], default: false },
    checkbox: { type: [Boolean, null], default: false },
    checkboxColor: { default: null },
    prependIcon: { type: [Boolean, null], default: true },
    dense: { type: [Boolean, null], default: false },
    truncate: { type: [Boolean, null], default: true }
  },
  emits: ["select", "expand"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'select', value: PickerItemType): void
  (event: 'expand', value: PickerItemType): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { item: PickerItemType, isSelected: boolean | null, checkbox: boolean | null, checkboxColor: string | null, prependIcon: boolean | null, dense: boolean | null, truncate: boolean | null }





const handleSelect = () => {
  emit('select', props.item)
}

const clickRow = () => {
  if (props.item.expandable) {
    emit('expand', props.item)
  } else if (props.item.selectable) {
    emit('select', props.item)
  }
}

const listItemClass = computed(() => ({
  'item-selected-background': !props.prependIcon && props.isSelected,
}))

return { __sfc: true,props, emit, handleSelect, clickRow, listItemClass, VsText }
}

})